/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

import React, { Component } from 'react'
import { Dropdown, Form, Button, Icon, Popup } from 'semantic-ui-react'
import {propsAreEqual_NoRerenderNeeded} from '../CBP_App/reducer/util'
import isEqual from 'lodash/isEqual'
import map from 'lodash/map'

export class DropDown extends Component {
  constructor() {
    super()
    this.state = {}
  }

  shouldComponentUpdate(nextProps, nextState){
    if(window.slowstate)return true;

    return !propsAreEqual_NoRerenderNeeded(this.props,nextProps) || !isEqual(this.state,nextState) ;

  }
  
  errorPopup = (errors, label) => {
    if(!errors){
      return (<label>{label}</label>);
    }else if(!errors.length){
      return (<label>{label}</label>);
    }
    const error = errors.map((info, index) => {
      return (
        <div className='error' key={index}>
          * {info}
        </div>
      )
    })
    return (
      <label style={{"width": "100%",minWidth:'50px'}}>
        <span style={{"width": "90%", "overflow": "ellipsis"}} title={label}>{label}</span>
        <Popup 
          trigger={<Icon style={{"float": "right"}} 
          name='info circle' 
          size='small' 
          color='red' 
          />} 
          content={error || ''}
        />
      </label>
    )
  }

  getDropDownText = (option) => {
    if (option.stringVal) { // If there is a stringVal, use that
      return option.stringVal
    } else {
      // If not stringVal, it is likely a Master
      if (option.id && !option.description) { // If master (ie there is an id), return only the id if there is no description
        return option.id
      } else if(this.props.hidePrefix){
        return option.description
      } else if (option.id && option.description) { // Return combo of both is id and description are present
        return option.id + ' - ' + option.description
      } else if (option.value && option.description) { // Return combo of both is id and description are present
        return option.value + ' - ' + option.description
      }
    }
    // If no matches were found
    if(option && option.value)return option.value;
    if(typeof option != 'string')return "N/A"+((option && option.description)?` - ${option.description}`:"");
    return option
    
  }

  getDropDownValue = (option) => {
    if (option.stringVal) { // If there is a stringVal, use that
      return option.stringVal
    } else {
      // If not stringVal, it is likely a Master
      if (option.id) { // If master (ie there is an id), return the id
        return option.id
      } else if (option.value) { // If master (ie there is an value), return the value
        return option.value
      }
    }
    // If no matches were found
    if(typeof option != 'string')return "";
    return option
  }

  handleChange = (e, { value }) => {
    this.props.onChange(value)
  }

  render() {
    const {
      label,
      className,
      columnClassName,
      width,
      data,
      disabled,
      direction,
      labelClassName,
      centerSelect,
      onChange,
      text,
      onBlur,
      id,
      onButtonClick,
      button,
      handleFocus,
      labelIcon,
      setINPUTID,
      shipmentId,
      penClicked,
      error,
      inline,
      errors,
      uiDisabledTwo,
      searchInput,
      searchQuery,
      search,
    } = this.props
    let newLabel = this.errorPopup(errors, label);
    let drop_data = data === undefined ? [1, 2] : data
    const options = map(drop_data, (item, index) => {
        var txt = this.getDropDownText(item);
        return ({
        key: index,
        text: typeof txt === 'string' ? txt.replace('MOT_', '').replace('_MOT', '') : txt,
        value: this.getDropDownValue(item)
      })
    })
    let haserrors = (errors && errors.length >0)?" error ":" ";
    return (
      <Form.Input width={width}>
        {newLabel}
        <Dropdown
          clearable={this.props.clearable}
          lazyLoad={true}
          closeOnChange
          selectOnBlur={false}
          scrolling
          search={search !== undefined ? search : true}
          selection
          searchInput={searchInput}
          searchQuery={searchQuery}
          options={options}
          onChange={(e, { value }) => {
            if(onChange) {
              this.handleChange(e, { value });
            }
            if(text !== value && onBlur) {
              onBlur(e);
            }
          }}
          value={text}
          text={text}
          inline={inline}
          id={id + shipmentId}
          name={id + shipmentId}
          direction={direction}
          disabled={disabled || uiDisabledTwo}
          title={errors&&errors.length?errors[0]:null}
          className={className+haserrors}
          selectOnNavigation={false}
          onBlur={(event) => {
            if(!onBlur) {
              if (event && event.target.value) {
                let valueee = (event.target.value + "").toUpperCase().replaceAll(" ","");
                if(options.find(a => a.value == valueee) ){
                  onChange(valueee);
                } else {
                  let filteredList = options.filter(a => {
                    let filterstrrring = ((a.text?a.text:"")+"  "+(a.description?a.description:"")).split("-").filter(a=>a.trim().length>3).join('').toUpperCase()
                    return filterstrrring.trim().indexOf(valueee)==0;
                  });
                  if(filteredList && filteredList.length == 1 ){
                    onChange(filteredList[0].value);
                  }
                }
              }
            }
            document.getElementsByClassName('active-label')[0] && document.getElementsByClassName('active-label')[0].classList.remove('active-label')
          }}
          onFocus={event => {
            document.getElementsByClassName('active-label')[0] && document.getElementsByClassName('active-label')[0].classList.remove('active-label')
            document.getElementById(id + shipmentId).previousSibling &&
              document.getElementById(id + shipmentId).previousSibling.classList.add('active-label')
            handleFocus && handleFocus(event)
            event.target && event.target.setAttribute("autocomplete", "nope");
            // setINPUTID && setINPUTID(id + shipmentId)
          }}
          onMouseDown={e => {
            e.stopPropagation()
            // penClicked && penClicked(e)
          }}
        />
        {button && (
          <Button
            basic
            color='blue'
            className='openButton'
            onClick={e => onButtonClick(e)}
          >
            {button}
          </Button>
        )}
      </Form.Input>
    )
  }
}

export default DropDown
